<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="11.9998" cy="11.9998" r="9.00375" stroke="#DEC30C" stroke-width="2" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M11 15.5002H13.3103" stroke="#DEC30C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12.1583 15.4998V11.248H11.0078" stroke="#DEC30C" stroke-width="2" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M12.1019 8.24435C12.1019 8.38248 11.9899 8.49445 11.8518 8.49445C11.7136 8.49445 11.6017 8.38248 11.6017 8.24435C11.6017 8.10622 11.7136 7.99424 11.8518 7.99424"
    stroke="#DEC30C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.8517 7.9943C11.9898 7.9943 12.1018 8.10627 12.1018 8.2444" stroke="#DEC30C" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>